import { render } from "./DonorAcceptabilitySectionDetailsEMROATS.vue?vue&type=template&id=ca246d7c&scoped=true"
import script from "./DonorAcceptabilitySectionDetailsEMROATS.vue?vue&type=script&lang=js"
export * from "./DonorAcceptabilitySectionDetailsEMROATS.vue?vue&type=script&lang=js"

import "./DonorAcceptabilitySectionDetailsEMROATS.vue?vue&type=style&index=0&id=ca246d7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca246d7c"],['__file',"src/components/DonorAcceptabilitySectionDetailsEMROATS.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ca246d7c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ca246d7c', __exports__)) {
    api.reload('ca246d7c', __exports__)
  }
  
  module.hot.accept("./DonorAcceptabilitySectionDetailsEMROATS.vue?vue&type=template&id=ca246d7c&scoped=true", () => {
    api.rerender('ca246d7c', render)
  })

}


export default __exports__